import { useState, useEffect } from 'react';
import { clientContactService } from '../services/clientContactService';
import type { ClientContact } from '@shared/types';

export function useClientContacts(clientId: string) {
  const [contacts, setContacts] = useState<ClientContact[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadContacts = async () => {
    if (!clientId) {
      setContacts([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await clientContactService.getClientContacts(clientId);
      console.log('Loaded contacts:', data); // Debug
      setContacts(data);
    } catch (err) {
      console.error('Error loading contacts:', err); // Debug
      setError(err instanceof Error ? err.message : 'Failed to load contacts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadContacts();
  }, [clientId]);

  return {
    contacts,
    loading,
    error,
    reload: loadContacts,
  };
}

